var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.904,
    height: 60.872,
    viewBox: "0 0 43.904 60.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    d: "M7.876,20.951V59a3.621,3.621,0,0,0,3.377,3.8H41.648A3.621,3.621,0,0,0,45.025,59V20.951H7.876ZM18.008,55.191H14.63V28.56h3.377Zm6.754,0H21.385V28.56h3.377Zm6.754,0H28.139V28.56h3.377Zm6.754,0H34.894V28.56h3.377Zm7.6-45.654H34.894V4.781a2.716,2.716,0,0,0-2.533-2.853H20.54a2.716,2.716,0,0,0-2.533,2.853V9.537H7.032A2.716,2.716,0,0,0,4.5,12.39v4.756H48.4V12.39a2.716,2.716,0,0,0-2.533-2.853Zm-14.353,0H21.385V5.78H31.516V9.537Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#716F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.ab5d959aed41fa1be7a245096135bbda.svg";
export { ForwardRef as ReactComponent };